class ScrollToTheNextSection {
    constructor(options) {
        const defaultOptions = {
            sectionSelector: "section",
            buttonSelector: ".js-scroll-to-the-next-section",
            offsetTopElementSelector: "header",
        };

        this.options = Object.assign(defaultOptions, options);

        this.init();
    }

    getScrollPosition(section) {
        const sectionTop = section.offsetTop;
        let sectionBottom = sectionTop + section.offsetHeight;

        const { offsetTopElementSelector } = this.options;
        if (offsetTopElementSelector) {
            const offsetTop = document.querySelector(
                offsetTopElementSelector
            )?.offsetHeight;
            offsetTop && (sectionBottom -= offsetTop);
        }

        return sectionBottom;
    }

    handleScroll(scrollPosition) {
        window.scrollTo({ top: scrollPosition, behavior: "smooth" });
    }

    attachButtonEvents(section, button) {
        button.addEventListener("click", () => {
            const scrollPosition = this.getScrollPosition(section);
            this.handleScroll(scrollPosition);
        });
    }

    init() {
        const { sectionSelector, buttonSelector } = this.options;
        if (!sectionSelector || !buttonSelector) return false;

        const button = document.querySelector(buttonSelector);
        const section = button?.closest(sectionSelector)
            ? button.closest(sectionSelector)
            : document.querySelector(sectionSelector);

        if (!section || !button) return false;

        this.attachButtonEvents(section, button);
    }
}

const scrollToNextSection = new ScrollToTheNextSection({
    sectionSelector: ".voyager-hero-with-introduction",
    buttonSelector: ".voyager-hero-with-introduction__arrow-scroll",
    offsetTopElementSelector: ".voyager-header",
});

const scrollToNextSectionHero = new ScrollToTheNextSection({
    sectionSelector: ".voyager-hero",
    buttonSelector: ".js-hero-scrollto",
    offsetTopElementSelector: ".voyager-header",
});

const scrollToNextSectionHeroGallery = new ScrollToTheNextSection({
    sectionSelector: ".voyager-hero-gallery",
    buttonSelector: ".js-hero-gallery-scrollto",
    offsetTopElementSelector: ".voyager-header",
});
